import React from "react";
import {
  PhoneIcon,
  EnvelopeIcon,
  DevicePhoneMobileIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faXTwitter,
  faWhatsapp,
  faLinkedin,
  faTiktok,
  faYoutube,
  faInstagram,
  faSnapchat,
  faBehance,
} from "@fortawesome/free-brands-svg-icons";
import UnderLineForm from "../sharedComponents/UnderLineForm";
import translations from "../../locales/en.json";

const ContactUs = ({ phonesTel, phonesMob, email, address }) => {
  const { contactus } = translations;

  return (
    <section className="grid grid-cols-1 gap-8 mb-10 md:mt-6 md:mb-12 md:p-0 max-container md:grid-cols-1 lg:grid-cols-1">
      {/* Left Side - Contact Info */}
      {/* <div className="flex flex-col justify-center space-y-6 text-white bg-black shadow-md text-start max-auto rounded-2xl">
        <div className="flex flex-col justify-start text-start mx-auto bg-black text-white rounded-2xl space-y-4 py-16 shadow-md lg:w-[70%] w-[85%]">
          <h2 className="text-2xl font-bold">{contactus?.contactus}</h2>
          <p className="text-gray-400">{contactus?.contactdes}</p>
          <a
            href={`tel:${phonesTel}`}
            className="flex items-start justify-start gap-3 text-white duration-300 hover:text-custom-primary group"
          >
            <DevicePhoneMobileIcon className="w-5 h-5 text-white duration-300 group-hover:text-custom-primary" />
            {phonesTel}
          </a>
          <a
            href={`tel:${phonesMob}`}
            className="flex items-start justify-start gap-3 text-white duration-300 hover:text-custom-primary group"
          >
            <PhoneIcon className="w-5 h-5 text-white duration-300 group-hover:text-custom-primary" />
            {phonesMob}
          </a>
          <a
            href={`mailto:${email}`}
            className="flex items-start justify-start gap-3 text-white duration-300 hover:text-custom-primary group"
          >
            <EnvelopeIcon className="w-5 h-5 text-white duration-300 group-hover:text-custom-primary" />
            {email}
          </a>

          <a
            href="https://maps.app.goo.gl/jaRMSN3ZGjEc3wL26"
            target="_blank"
            className="flex items-start justify-start gap-3 text-white duration-300 hover:text-custom-primary group"
          >
            <MapPinIcon className="w-5 h-5 text-white duration-300 group-hover:text-custom-primary" />
            {address}
          </a>

          <div className="flex flex-wrap items-start justify-start w-full gap-4 text-2xl max-container">
            <a
              href="https://www.facebook.com/workbrandeg/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faFacebook} className="text-white" />
            </a>

            <a
              href="https://www.instagram.com/workbrandeg/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faInstagram} className="text-white" />
            </a>

            <a
              href="https://eg.linkedin.com/company/workbrandeg"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faLinkedin} className="text-white" />
            </a>

            <a
              href="https://www.youtube.com/@workbrand1540"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faYoutube} className="text-white" />
            </a>

            <a
              href="https://www.tiktok.com/@workbrandeg?_t=ZS-8zOGn4WKW1q&_r=1"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faTiktok} className="text-white" />
            </a>

            <a
              href="https://snapchat.com/t/2oJ9hqAZ"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faSnapchat} className="text-white" />
            </a>

            <a
              href="https://x.com/workbrandeg"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faXTwitter} className="text-white" />
            </a>

            <a
              href="https://www.behance.net/WorkBrandAgency/services"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:scale-105 hover:text-custom-primary"
            >
              <FontAwesomeIcon icon={faBehance} className="text-white" />
            </a>
          </div>
        </div>
      </div> */}

      {/* Right Side - Form */}
      <UnderLineForm />
    </section>
  );
};

export default ContactUs;
